import React from 'react'

/**
 * @typedef {object} FieldErrorProps
 * @property {string} elmId
 * @property {React.ReactNode} [error]
 * @property {string} [className]
 * @property {boolean} [showError]
 * @property {boolean} [fluid]
 * @property {boolean} [hideWrapper]
 */
import classnames from 'classnames/bind'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

const FieldError = props => {
  const { className, elmId, error } = props

  return (
    <div data-elm-id={`${elmId}_error`} className={cx('error', className)}>
      {error}
    </div>
  )
}

export default FieldError
